<template>
	<div>
		<div class="head">
			<img src="@/assets/headImg/head.jpg" style="width: 100%; 
		vertical-align:top;" class="lunbo1" />
			<img src="../../assets/lunbo.jpg" style="width: 100%;" class="lunbo2">
			<div class="retrun" @click="retrun">
				返回首页
			</div>
		</div>
		<div class="signin">
			<p class="title">用户登录</p>
			<el-tabs v-model="activeName" :stretch="true" @tab-click="handleClick">
				<el-tab-pane label="账号密码登录" name="pwd">
					<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">

						<el-form-item label="" prop="accountNumber">
							<el-input v-model="ruleForm.accountNumber" placeholder="请输入手机号" ref="atlas-name-input"></el-input>
						</el-form-item>

						<el-form-item label="" prop="pass">
							<el-input type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="请输入密码"></el-input>
						</el-form-item>

						<el-form-item>
							<el-button type="primary" @click="submitForm('ruleForm')" style="width: 100%;" class="signinbtn">登录</el-button>
							<el-button type="primary" @click="register" style="width: 100%;margin: 0;margin-top: 20px;" class="zucbtn">新用户注册</el-button>
						</el-form-item>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="手机验证码登录" name="code">
					<el-form :model="coderuleForm" status-icon :rules="coderules" ref="coderuleForm" class="demo-ruleForm">
						<el-form-item label="" prop="accountNumber">
							<el-input v-model="coderuleForm.accountNumber" placeholder="请输入手机号"></el-input>
						</el-form-item>
						<el-form-item label="" prop="code">
							<el-input placeholder="请输入验证码" v-model="coderuleForm.code" autocomplete="off" class="input-with-select">
								<el-button slot="append" @click="sendSms('coderuleForm')" :disabled="!show">
									<span v-show="show">获取验证码</span>
									<span v-show="!show" class="count">{{count}} s</span>
								</el-button>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="loginCode('coderuleForm')" style="width: 100%;" class="signinbtn">登录</el-button>

							<el-button type="primary" @click="register" style="width: 100%;margin: 0;margin-top: 20px;" class="zucbtn">新用户注册</el-button>
						</el-form-item>
					</el-form>
				</el-tab-pane>
			</el-tabs>
			<div class="flex">
				<div>
					<el-radio v-model="remember" label="1">记住账号</el-radio>
				</div>
				<!-- <div style="color: #666;font-size:14px;">
					<img src="../../assets/weixinlog.jpg" v-if="!isWeiXin()" @click="oauth" style="width: 35px;height: 35px;cursor: pointer;" />
					<img src="../../assets/weixinlog.jpg" v-if="isWeiXin()" @click="weixinoauth" style="width: 35px;height: 35px;cursor: pointer;" />
				</div> -->
			</div>
		</div>
		<el-dialog title="提示" :visible.sync="dialogVisible" width="80%" :before-close="()=>{dialogVisible=false}"
		 :close-on-click-modal=false>
			<div v-if="isShow">
				<p>您之前注册时未填写身份证等信息，根据要求，请您完善信息...</p>
				<p slot="footer" class="dialog-footer" style="text-align: right;">
					<el-button @click="exit">取 消</el-button>
					<el-button type="primary" @click="showForm">去完善</el-button>
				</p>
			</div>
			<div v-else>
				<el-form :model="reForm" status-icon :rules="rules" ref="reForm" class="demo-ruleForm">

					<!-- 	<el-form-item label="手机号码" prop="phoneNumber">
						<el-input v-model.number="reForm.phoneNumber" placeholder="请输入手机号码"></el-input>
					</el-form-item> -->

					<el-form-item label="真实姓名" prop="name">
						<el-input v-model="reForm.name" placeholder="请输入姓名"></el-input>
					</el-form-item>

					<el-form-item label="身份证号" prop="IdCard">
						<el-input v-model="reForm.IdCard" placeholder="请输入身份证号"></el-input>
					</el-form-item>

					<el-form-item label=" " prop="isIdac">
						<div class="flex">
							<span style="margin-right: 1.25rem;color: #535353;">是否参加4月11日IDAC会议</span>
							<el-radio v-model="reForm.isIdac" label="是">是</el-radio>
							<el-radio v-model="reForm.isIdac" label="否">否</el-radio>
						</div>
					</el-form-item>

					<!-- <el-form-item label="专业" prop="field">
						<el-input v-model="reForm.id" placeholder="请选择专业"></el-input>
					</el-form-item> -->

					<!-- <el-form-item label="电子邮箱" prop="mailbox">
						<el-input v-model="reForm.email" placeholder="请输入电子邮箱"></el-input>
					</el-form-item>
				
					<el-form-item label="所属地区" prop="province">
						<div style="margin-top: 40px;"></div>
						<el-input v-model="reForm.district" placeholder="所属地区"></el-input>
					</el-form-item>
				
					<el-form-item label="工作单位" prop="company">
						<el-input v-model="reForm.company" placeholder="请输入工作单位"></el-input>
					</el-form-item> -->

					<!-- <el-form-item label="通讯地址" prop="postalAddress">
						<el-input v-model="reForm.postalAddress" placeholder="请输入通讯地址"></el-input>
					</el-form-item> -->

					<!-- <el-form-item label="科室/部门" prop="department">
						<el-input v-model.number="reForm.department" placeholder="请输入科室/部门"></el-input>
					</el-form-item>
				
					<el-form-item label="职称" prop="title">
							<el-input v-model="reForm.jobTitle" placeholder="请选择职称"></el-input>
					</el-form-item> -->

					<!-- <el-form-item label="出生日期" prop="birthday">
						<div class="block">
							<el-date-picker v-model="ruleForm.birthday" type="date" placeholder="选择日期">
							</el-date-picker>
						</div>
					</el-form-item> -->

					<!-- <el-form-item label="是否来自基层社区医院" prop="radio2">
						<div>
							<el-select v-model="reForm.radio2" placeholder="请选择是否来自基层社区医院" style="width: 100%;">
								<el-option v-for="item in grade" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</div>
					</el-form-item>
				
					<el-form-item label="最高学历" prop="radio">
						<div>
							<el-radio v-model="reForm.radio" label="博士研究生">博士研究生</el-radio>
							<el-radio v-model="reForm.radio" label="硕士研究生">硕士研究生</el-radio>
							<el-radio v-model="reForm.radio" label="本科">本科</el-radio>
							<el-radio v-model="reForm.radio" label="大专">大专</el-radio>
							<el-radio v-model="reForm.radio" label="中专">中专</el-radio>
							<el-radio v-model="reForm.radio" label="其他">其他</el-radio>
						</div>
					</el-form-item> -->

					<el-form-item>
						<el-button type="primary" @click="submitUpdate(reForm)" style="width: 100%;margin-top: 1.25rem;">提交</el-button>
					</el-form-item>
				</el-form>
			</div>

		</el-dialog>
		<logocom style="margin-top: 100px;" class="isshow"></logocom>
	</div>
</template>

<script>
	import logocom from '@/components/logo/logo.vue';
	import md5 from 'js-md5';
	export default {
		data() {
			var accountNumber = (rule, value, callback) => {
				let mobilePhone = /^1[3|4|5|7|8|9][0-9]{9}$/;
				let email = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
				if (!value) {
					return callback(new Error('账号不能为空'));
				}
				setTimeout(() => {
					if (mobilePhone.test(value)) {
						callback();
					} else {
						callback(new Error('请输入有效值'));
					}
				}, 500);
			};

			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					if (this.ruleForm.checkPass !== '') {
						this.$refs.ruleForm.validateField('checkPass');
					}
					callback();
				}
			};
			// 身份证验证
			var yzID = (rule, value, callback) => {
				var reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
				console.log(value, '999');
				setTimeout(() => {
					if (!(reg.test(value))) {
						callback(new Error('请输入有效的身份证号'));
					} else {
						return callback();
					}

				}, 500);
			};
			var valiCode = (rule, value, callback) => {
				console.log(value)
				if (value === '') {
					callback(new Error('请输入验证码'));
				} else if (value.length != 6) {
					callback(new Error('验证码6位数'));
				} else {
					callback();
				}
			};
			var isIdac = (rule, value, callback) => {
				console.log("是否参加411会议", value);
				if (value == '' || value == null) {
					return callback(new Error('请选择是或否'));
				}
				return callback();
			};
			return {
				keyList: [{
						id: "475119",
						key: "hzt5jS50BFrL",
					}, {
						id: "543866",
						key: "xyfMa27hcIZE",
					},
					{
						id: "475024",
						key: "RHRaEHP0fU2D",
					}, {
						id: "475025",
						key: "JQ0OQB4B7XDs",
					}, {
						id: "475027",
						key: "Z1EaPsUs272B",
					}, {
						id: "475028",
						key: "MHmFGjguT3fR",
					}, {
						id: "475029",
						key: "mjkKGp7f4I76",
					}, {
						id: "475032",
						key: "eXhXeYJ8pSlT",
					},
					{
						id: "475037",
						key: "OvahmHAAJadX",
					}, {
						id: "475038",
						key: "xmnogi6whiEs",
					}, {
						id: "475041",
						key: "GzWnjVqtzrrp",
					}, {
						id: "475044",
						key: "Py13GlPs9MET",
					}, {
						id: "475045",
						key: "G6vFETwJWbZU",
					}, {
						id: "475046",
						key: "PV2bBoo9JqzZ",
					}
				],
				isShow: true,
				dialogVisible: false,
				show: true,
				count: "", // 初始化次数
				timer: null,
				activeName: 'pwd',
				remember: '',
				isonlineR: '',
				isteamR: '',
				reForm: {
					BirthDate: '',
					IdCard: '',
					checkPass: '',
					age: '',
					companyAddress: '',
					name: '',
					createTime: '',
					district: '',
					company: '',
					postalAddress: '',
					department: '',
					email: '',
					birthday: '',
					highestEducation: '',
					jobTitle: '',
					primaryHospital: '',
					nickName: '',
					phoneNumber: '',
					sex: '',
					userId: '',
					isIdac: '',
				},
				ruleForm: {
					pass: '',
					accountNumber: '',
					IdCard: '',
					isIdac: '',
				},
				coderuleForm: {
					code: '',
					accountNumber: ''
				},
				rules: {
					pass: [{
						validator: validatePass,
						trigger: 'blur'
					}],
					IdCard: [{
						validator: yzID,
						trigger: 'blur',
						required: true
					}],
					accountNumber: [{
						validator: accountNumber,
						trigger: 'blur'
					}],
					isIdac: [{
						validator: isIdac,
						trigger: 'change',
						required: true
					}],
				},
				coderules: {
					accountNumber: [{
						validator: accountNumber,
						trigger: 'blur'
					}],
					code: [{
						validator: valiCode,
						trigger: 'blur'
					}]
				}
			};
		},
		mounted() {
			// this.isonlineR = this.$route.query.isonline
			this.isteamR = this.$route.query.isteam
			console.log(this.isteamR)

			// if (localStorage.getItem("user") != null && this.dialogVisible == false) {
			// 	console.log("进入if")
			// 	this.$api.exit({
			// 		userId: JSON.parse(localStorage.getItem("user")).user.userId
			// 	}, res => {
			// 		console.log("进入exit接口")
			// 		localStorage.removeItem('user');
			// 		sessionStorage.removeItem('openId')
			// 		sessionStorage.removeItem('unionId')
			// 		sessionStorage.removeItem('nickName')
			// 		sessionStorage.removeItem('headImg')
			// 		console.log("缓存清除成功")
			// 		// this.$router.push({
			// 		// 	path: '/signIn'
			// 		// })
			// 	})
			// }
		},
		created() {
			var info = JSON.parse(localStorage.getItem("user"))
			if (localStorage.getItem("user") != null) {
				let form = JSON.parse(localStorage.getItem("user"));
				if (this.$route.fullPath.length > 50) {
					var key = this.getKey(this.$route.query.actId);
					var keyB = md5(info.user.phone + key)
					var expire = "1296000"
					window.location.href = "http://live-one.tscloud-tech.com/activity.php?a=userAssign&id=" +
						this.$route.query.actId + "&userid=" + form.user.phone + "&name=" + form.user.name +
						"&key=" + keyB + "&phone=" + form.user.phone + "&expire=" + expire
				}
			}else {
				console.log("目前无用户信息")
			}
		},
		components: {
			logocom
		},
		methods: {
			getKey(id) {
				// for (item of this.keyList) {
				// 	console.log(item)
				// 	if (item.id == id) {
				// 		console.log("找到key")
				// 		return item.key
				// 	}
				// }
				for (var i = 0; i < this.keyList.length; i++) {
					let item = this.keyList[i]
					if (item.id == id) {
						return item.key
					}
				}
			},
			handleClick(tab, event) {
				if (tab.name == 'pwd') {
					this.ruleForm.accountNumber = this.coderuleForm.accountNumber
				} else {
					this.coderuleForm.accountNumber = this.ruleForm.accountNumber
				}
			},
			loginCode(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let cnt = {
							phone: this.coderuleForm.accountNumber, // String 手机
							code: this.coderuleForm.code, // String <选填> 密码
							// isonline: this.isonlineR // String 线上还是线下
						}
						this.$api.loginByCode(cnt, res => {
							if (res.data && res.data.rc == this.$util.RC.SUCCESS) {
								let form = JSON.parse(res.data.c);
								this.reForm.IdCard = form.user.IdCard;
								this.reForm.name = form.user.name;
								this.reForm.userId = form.user.userId;
								this.reForm.isIdac = form.user.isIdac;
								if (form.user.isonline == "是") {
									this.$message.success('登录成功')
									localStorage.setItem("user", res.data.c);
									this.$router.push({
										path: '/'
									})
								} else {
									if (form.user.IdCard == "" || form.user.IdCard == undefined || form.user.isIdac == undefined) {
										localStorage.setItem("user", res.data.c);
										this.dialogVisible = true;
									} else {
										this.$message.success('登录成功')
										localStorage.setItem("user", res.data.c);
										this.$router.push({
											path: '/'
										})
									}
								}
							} else {
								this.$message.error(res.data.rm);
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			sendSms(formName) {
				this.$refs[formName].validateField('accountNumber', valid => {
					if (!valid) {
						this.codeSetTime()
						this.$api.sendSms({
							phone: this.coderuleForm.accountNumber
						}, res => {
							if (res.data && res.data.rc == this.$util.RC.SUCCESS) {
								this.$message.success(res.data.c)
							} else {
								this.show = true;
								clearInterval(this.timer); // 清除定时器
								this.timer = null;
								this.$message.error(res.data.rm);
							}
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			codeSetTime() {
				const TIME_COUNT = 60; //更改倒计时时间
				if (!this.timer) {
					this.count = TIME_COUNT;
					this.show = false;
					this.timer = setInterval(() => {
						if (this.count > 0 && this.count <= TIME_COUNT) {
							this.count--;
						} else {
							this.show = true;
							clearInterval(this.timer); // 清除定时器
							this.timer = null;
						}
					}, 1000);
				}
			},
			oauth() {
				let AppId = "wx071f0505cd65dd67"; //
				let score = 'snsapi_login' //
				let redirect_urls = encodeURIComponent("http://bisc2021.ganzhiyu.com/index.html#/pcLogin");
				let urls = " https://open.weixin.qq.com/connect/qrconnect?appid=" + AppId + "&redirect_uri=" + redirect_urls +
					"&response_type=code&scope=" + score + "&state=STATE#wechat_redirect";
				window.location.href = urls;
			},
			weixinoauth() {
				//    snsapi_base  snsapi_userinfo 第一步用户授权，跳转目标页，在下一页得到code
				let AppId = "wxc17e1b4c4aceccbb"; //公众号的唯一标识,开发者ID
				let score = 'snsapi_userinfo' //这里采用静默登录 //or snsapi_userinfo
				let redirect_urls = encodeURIComponent("http://bisc2021.ganzhiyu.com/index.html#/weixin");
				let urls = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + AppId + "&redirect_uri=" + redirect_urls +
					"&response_type=code&scope=" + score + "&state=STATE#wechat_redirect";
				window.location.href = urls;
			},
			// 判断是否是微信端浏览器
			isWeiXin() {
				var ua = window.navigator.userAgent.toLowerCase();
				if (ua.match(/MicroMessenger/i) == 'micromessenger') {
					return true; // 是微信端
				} else {
					return false;
				}
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let cnt = {
							phone: this.ruleForm.accountNumber, // String 手机
							pwd: this.ruleForm.pass, // String <选填> 密码
							// isonline: this.isonlineR // String 线上还是线下
							// code: code, // String <选填> 微信code
						};
						// unionId存在
						if ((sessionStorage.getItem('unionId') != null && sessionStorage.getItem('unionId') != '')) {
							cnt.openId = sessionStorage.getItem('openId')
							cnt.unionId = sessionStorage.getItem('unionId')
							cnt.nickName = sessionStorage.getItem('nickName')
							cnt.headImg = sessionStorage.getItem('headImg')
						}
						this.$api.login(cnt, res => {
							if (res.data && res.data.rc == this.$util.RC.SUCCESS) {
								let form = JSON.parse(res.data.c);
								this.reForm.BirthDate = form.user.BirthDate;
								this.reForm.IdCard = form.user.IdCard;
								this.reForm.age = form.user.age;
								this.reForm.company = form.user.company;
								this.reForm.companyAddress = form.user.companyAddress;
								this.reForm.createTime = form.user.createTime;
								this.reForm.department = form.user.department;
								this.reForm.district = form.user.district;
								this.reForm.email = form.user.email;
								this.reForm.highestEducation = form.user.highestEducation;
								this.reForm.jobTitle = form.user.jobTitle;
								this.reForm.name = form.user.name;
								this.reForm.nickName = form.user.nickName;
								this.reForm.phoneNumber = form.user.phone;
								this.reForm.sex = form.user.sex;
								this.reForm.userId = form.user.userId;
								this.reForm.isIdac = form.user.isIdac;
								if (form.user.isonline == "是") {
									this.$message({
										message: '登录成功',
										type: 'success'
									})
									if (this.$route.fullPath.length > 50) {
										localStorage.setItem("user", res.data.c);
										var key = this.getKey(this.$route.query.actId);
										var keyB = md5(form.user.phone + key)
										var expire = "1296000"
										window.location.href = "http://live-one.tscloud-tech.com/activity.php?a=userAssign&id=" +
											this.$route.query.actId + "&userid=" + form.user.phone + "&name=" + form.user.name +
											"&key=" + keyB + "&phone=" + form.user.phone + "&expire=" + expire
									} else {
										localStorage.setItem("user", res.data.c);
										this.$router.push({
											path: '/'
										})
									}
								} else {
									if (form.user.IdCard == "" || form.user.IdCard == undefined || form.user.isIdac == undefined) {
										localStorage.setItem("user", res.data.c);
										this.dialogVisible = true;
									} else {
										this.$message({
											message: '登录成功',
											type: 'success'
										})
										if (this.$route.fullPath.length > 50) {
											localStorage.setItem("user", res.data.c);
											var key = this.getKey(this.$route.query.actId);
											var keyB = md5(form.user.phone + key)
											var expire = "1296000"
											window.location.href = "http://live-one.tscloud-tech.com/activity.php?a=userAssign&id=" +
												this.$route.query.actId + "&userid=" + form.user.phone + "&name=" + form.user.name +
												"&key=" + keyB + "&phone=" + form.user.phone + "&expire=" + expire
										} else {
											localStorage.setItem("user", res.data.c);
											this.$router.push({
												path: '/'
											})
										}
									}
								}

							} else {
								this.$message.error(res.data.rm);
							}
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			exit() {
				this.dialogVisible = false;
				if (this.dialogVisible == false) {
					this.$api.exit({
						userId: JSON.parse(localStorage.getItem("user")).user.userId
					}, res => {
						localStorage.removeItem('user');
						// this.$router.push({
						// 	path: '/signIn'
						// })
					})
				}
			},
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
				this.dialogVisible = false;
			},
			showForm() {
				this.isShow = false;
				let messForm = JSON.parse()
			},
			submitUpdate() {
				let cnt = {
					IdCard: this.reForm.IdCard,
					userId: this.reForm.userId,
					isIdac: this.reForm.isIdac,
				}
				this.$api.updateUser(cnt, res => {
					if (res.data && res.data.rc == this.$util.RC.SUCCESS) {
						this.$message({
							message: '登录成功',
							type: 'success'
						})
						var info = localStorage.getItem("user");
						if (this.$route.fullPath.length > 50) {
							var key = this.getKey(this.$route.query.actId);
							var keyB = md5(info.phone + key)
							var expire = "1296000"
							window.location.href = "http://live-one.tscloud-tech.com/activity.php?a=userAssign&id=" +
								this.$route.query.actId + "&userid=" + info.phone + "&name=" + info.name + "&key=" + keyB +
								"&phone=" + info.phone + "&expire=" + expire
						} else {
							this.$router.push({
								path: '/'
							})
						}
					}
				})
			},
			retrun: function() {
				this.$router.push({
					path: '/'
				})
			},
			register: function() {
				if (this.isWeiXin()) {
					this.$router.push({
						path: './seleteSignln',
						query: {
							unionId: this.$route.query.unionId,
							openId: this.$route.query.openId,
							nickName: this.$route.query.nickName,
							headImg: this.$route.query.headImg,

						}
					})
				} else {
					this.$router.push({
						path: './seleteSignln',
						query: {
							team: this.isteamR
						}
					})
				}
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
		}
	}
</script>

<style scoped>
	.signin {
		width: 430px;
		/* background-color: darkgoldenrod; */
		margin: 80px auto;
	}

	.head {
		width: 980px;
		margin: 0 auto;
		padding-right: 16px;
	}

	.retrun {
		margin-top: 10px;
		cursor: pointer;
		margin-left: 10px;
		color: rgb(20, 90, 245);
	}

	.retrun:hover {
		color: #49bee5;
	}

	.title {
		font-size: 18px;
		font-weight: bold;
		color: #333;
		text-align: center;
	}

	.flex {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.signinbtn {
		background-image: linear-gradient(to right, #5173ff, #3dbbff);
	}

	.zucbtn {
		background-image: linear-gradient(to right, #ff8251, #ffb33d);
		border: none;
	}

	.lunbo2 {
		display: none;
	}

	.isshow {
		visibility: hidden;
	}

	@media (max-width: 980px) {
		.head {
			width: 100%;
		}
	}

	@media (max-width: 680px) {
		.signin {
			width: 70%;
			margin: 0 auto;
		}
	}

	@media (max-width:500px) {
		.lunbo1 {
			display: none;
		}

		.lunbo2 {
			display: block;
		}

		.isshow {
			visibility: visible;
		}

		.head {
			padding-right: 0;
		}

	}
</style>
